import { configureStore } from "@reduxjs/toolkit";
import budataSlicereducer from "./budata-slice";
import notificationSliceReducer from "./notification";
import redirectSliceReducer from "./redirect-slice";
import loadingSliceReducer from "./loading-slice";
import getDataSliceReducer from "./getdata";
import totalBillSliceReducer from "./total-bill-slice";

const store = configureStore({
    reducer: {
        'budata': budataSlicereducer,
        'notification': notificationSliceReducer,
        'redirect': redirectSliceReducer,
        'loading': loadingSliceReducer,
        'getdata': getDataSliceReducer,
        'totalBill': totalBillSliceReducer
    }
});

export default store;